import {
    companySlug,
    productSlug,
    ingredientSlug,
    packagingSlug,
    supplierSlug,
    SettingsSlug,
    CsrStrategySlug,
    loginSlug,
    logoutSlug,
    noCompanySlug,
    consentsSlug,
    documentationSlug,
} from "src/services/URLHandler";

export const reservedPrefixes: string[] = [
    `/${SettingsSlug}`,
    `/${companySlug}`,
    `/${productSlug}`,
    `/${ingredientSlug}`,
    `/${packagingSlug}`,
    `/${supplierSlug}`,
    `/${CsrStrategySlug}`,
    `/${loginSlug}`,
    `/${logoutSlug}`,
    `/${noCompanySlug}`,
    `/${consentsSlug}`,
    `/${documentationSlug}`,
];

export const normalizeUrl = (value: string): string => {
    if (!value) return "";
    let v = value.trim();
    if (!v.startsWith("/")) v = "/" + v;
    if (v.length > 1 && v.endsWith("/")) v = v.slice(0, -1);
    return v;
};

export const isUrlReserved = (value: string): boolean => {
    const v = normalizeUrl(value);
    if (v === "/") return false; // home is overridable
    return reservedPrefixes.some((prefix) => v === prefix || v.startsWith(prefix + "/"));
};

export const isUrlValid = (value: string): boolean => {
    const v = normalizeUrl(value);
    if (v === "") return false;
    if (!/^\/[A-Za-z0-9\-_/]*$/.test(v)) return false;
    if (isUrlReserved(v)) return false;
    return true;
};
